import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text, Flex } from 'components/ui';
import {
    colors, space, radii, mediaQueries, shadows
} from 'style/config';
import { MAX_PRODUCTS } from 'components/Catalog/ProductGrid/CompareModal/constants';
import { zoneStyles } from 'components/Catalog/ProductGrid/CompareModal/Zones/zoneStyles';

const ProductCardZone = ({ selectedProducts = [], getText = () => {} }) => {
    // Render product card content for a specific product
    const renderProductCardContent = (product, index) => {
        const isEmpty = !product;
        const slotKey = product?.productId ? `product-${product.productId}` : `slot-${index}`;

        return (
            <Box
                key={slotKey}
                css={zoneStyles.productSlot}
                data-at={Sephora.debug.dataAt(`compare_modal_product_slot_${index + 1}`)}
            >
                {isEmpty ? (
                    <Box css={styles.emptySlot}>
                        <Text
                            fontSize='sm'
                            color='gray'
                            textAlign='center'
                        >
                            {getText('emptySlot')}
                        </Text>
                    </Box>
                ) : (
                    <Box css={styles.productCardZone}>
                        {/* Product card will be rendered here in FER-208 */}
                        <Text
                            fontSize='sm'
                            color='gray'
                        >
                            Product Card Zone
                        </Text>
                    </Box>
                )}
            </Box>
        );
    };

    return (
        <Box css={styles.stickyProductCardSection}>
            <Flex css={zoneStyles.productsContainer}>
                {Array.from({ length: MAX_PRODUCTS }, (_, index) => {
                    const product = selectedProducts[index];

                    return renderProductCardContent(product, index);
                })}
            </Flex>
        </Box>
    );
};

const styles = {
    stickyProductCardSection: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: colors.white,
        paddingTop: `${space[6]}px`,
        paddingBottom: `${space[2]}px`,
        paddingX: 0,
        marginX: `-${space[4]}px`,
        paddingLeft: `${space[4]}px`,
        paddingRight: `${space[4]}px`,
        boxShadow: shadows.light,
        marginBottom: `${space[4]}px`,
        [mediaQueries.sm]: {
            paddingLeft: `${space[5]}px`,
            paddingRight: `${space[5]}px`,
            marginX: `-${space[5]}px`
        }
    },
    emptySlot: {
        border: `2px dashed ${colors.inputGray}`,
        borderRadius: `${radii[2]}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.white,
        minHeight: '200px',
        padding: `${space[4]}px`
    },
    productCardZone: {
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[1]}px`,
        minHeight: '200px'
    }
};

ProductCardZone.propTypes = {
    selectedProducts: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(ProductCardZone, 'ProductCardZone');
